import { render, staticRenderFns } from "./CODstatistical.vue?vue&type=template&id=df978756&scoped=true"
import script from "./CODstatistical.vue?vue&type=script&lang=js"
export * from "./CODstatistical.vue?vue&type=script&lang=js"
import style0 from "./CODstatistical.vue?vue&type=style&index=0&id=df978756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df978756",
  null
  
)

export default component.exports